var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.warnings !== undefined)?_c('div',_vm._l(((_vm.warnings || [])),function(warning,idx){return _c('div',{key:idx,staticClass:"card-warning"},[_vm._v("\n    "+_vm._s(_vm.$t(_vm.descriptions[warning]))+"\n  ")])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }